export default __webpack_public_path__ + "media/images/gallery/19-94b0553c7aed08dff853aeaa7e8e70bb.jpg";